import { useMutation, useQueryClient } from '@tanstack/react-query';
import useAuth from 'hooks/useAuth.ts';
import { ApiResponse } from 'schemas/ApiResponse.schema.ts';
import { ITERATION_STATUS } from 'schemas/CampaignApiDetails.schema.ts';
import { apiFetch } from 'utils/apiUtils.ts';

interface UpdateIterationVariables {
  teamId: string,
  campaignId: string,
  iterationId: string,
  status: ITERATION_STATUS,
  reviewers?: string[],
}

export default function useUpdateIterationStatus() {
  const { tokens } = useAuth();
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['summary_report'],
    mutationFn: async ({
      teamId,
      campaignId,
      iterationId,
      status,
      reviewers,
    }: UpdateIterationVariables) => apiFetch<ApiResponse>({
      path: `team/${teamId}/campaign/${campaignId}/iteration/${iterationId}/status`,
      method: 'PUT',
      accessToken: String(tokens.accessToken),
      body: { status, ...(reviewers && { reviewers }) },
    }),
    onSuccess: async () => {
      await queryClient.refetchQueries({ queryKey: ['campaign'] });
      await queryClient.refetchQueries({ queryKey: ['summary_report'] });
    },
  });
}
